<template>
  <div v-if="isShow">
    <div class="search_box mod_row_flex mod_align_item_center">
      <img class="search_icon" src="../../assets/icon_search.png"/>
      <van-field v-model="searchText" type="number"  placeholder="请输入预订手机号" maxlength="11" style="flex: 1"/>
      <van-button class="search_button" @click="search" color="linear-gradient(-37deg, #00CCA7 0%, #29CA62 100%)">
        查询订单
      </van-button>
    </div>
    <div v-if="hasSearch && orderList.length > 0" class="order_list_box">
      <div v-for="(item, index) in orderList" class="order_list mod_column_flex" :key="index">
      <p class="order_name mod_single_line">{{ item.inn_name }}</p>
      <p class="order_address mod_single_line">{{ item.address }}</p>
      <div v-for="(orderItem, orderIndex) in item.order_list" :key="orderIndex" class="mod_row_flex order_item">
        <template v-if="item.type === 1">
          <div class="order_item_nights">{{orderItem.nights}}晚 </div>
          <div class="mod_column_flex mod_flex_1">
            <p class="order_item_room mod_single_line">{{ orderItem.room_name }}</p>
            <p class="order_item_room_type mod_single_line">{{ orderItem.room_type_name }}</p>
            <p class="order_item_date">{{ orderItem.checkin_date }} ～ {{ orderItem.checkout_date }}</p>
          </div>
        </template>
        <template v-else>
          <p class="order_one_note mod_single_line">{{ orderItem.desc }}</p>
        </template>
      </div>
      <div class="order_money_box mod_row_flex mod_align_item_center mod_justify_between">
        <div class="order_money_label">
          付款金额
          <span class="order_money_symbol">¥</span>
          <span class="order_money_text">{{item.amount}}</span>
        </div>
        <van-button class="order_pay_button" color="#00CB87" @click="goToPay(item.trade_no)" plain>前往支付</van-button>
      </div>
      <div class="order_tip">
        请与前台确认信息再支付
      </div>
    </div>
    </div>
    <div v-else-if="hasSearch && orderList.length === 0" class="order_empty mod_column_flex mod_align_item_center">
      <img class="order_empty_img" src="../../assets/icon_empty.png"/>
      <p class="order_empty_text">未查询到相关订单！</p>
    </div>
  </div>
</template>

<script>
import {getQueryBbj} from "@/utils/modUtils";
import {searchOrder} from "@/services/cashier";
import {Toast} from "vant";
export default {
  name: "OrderSearch",
  data(){
    return{
      searchText: "",
      urlParams: {},
      orderList: [],
      hasSearch: false,
      isShow: false
    }
  },
  mounted() {
    const user = JSON.parse(window.localStorage.getItem('userInfo'));
    console.log("user", user);
    const localWxCode = window.localStorage.getItem('wxCode')
    const _href = window.location.href
    const authCode = getQueryBbj(_href).auth_code
    // 获取当前url里的code
    const wxCode = getQueryBbj(_href).code
    if (wxCode && localWxCode && localWxCode !== wxCode){
      this.isShow = true;
    }else if (authCode){
      this.isShow = true;
    }
    this.parseUrl();
  },
  methods:{
    parseUrl(){
      const urlParams = getQueryBbj(window.location.href);
      if (urlParams.hotel_id){
        this.urlParams = urlParams;
      }else{
        Toast.fail("当前门店不存在");
      }
    },
    search(){

      Toast.loading({
        message:"查询中..."
      });
      searchOrder({
        phone: this.searchText,
        innid: this.urlParams.hotel_id
      }).then(res => {
        this.orderList = res.data;
      }).finally(() => {
        this.hasSearch = true;
        Toast.clear();
      });
    },
    goToPay(tradeNo){
      this.$router.push({
        name:"wxPay",
        query:{
          trade_no:tradeNo,
          isSearch: 1
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.search_box{
  height: 56px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: inset 0 0 0 0 #E9EAEC;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  .search_icon{
    width: 16px;
    height: 16px;
    margin-left: 12px;
  }
  .search_button{
    width: 80px;
    height: 32px;
    margin-right: 12px;
    font-size: 14px;
    padding: 0;
  }
}
.order_list_box{
  margin-top: 56px;
  padding: 10px 12px;
  .order_list{
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 10px;
    .order_name{
      height: 16px;
      font-weight: 500;
      font-size: 16px;
      color: #263341;
      letter-spacing: 0;
      line-height: 16px;
      margin: 16px 12px 0 12px;
    }
    .order_address{
      height: 16px;
      font-weight: 400;
      font-size: 12px;
      color: rgba(38,51,65,0.55);
      letter-spacing: 0;
      line-height: 16px;
      margin: 4px 12px 12px 12px;
    }
    .order_item{
      margin: 0 12px 16px 12px;
      .order_item_nights{
        width: 56px;
        height: 56px;
        background-image: linear-gradient(140deg, #454D61 0%, #7B859B 100%);
        border-radius: 4px;
        line-height: 56px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        flex-shrink: 0;
        margin-right: 8px;
      }
      .order_item_room{
        font-weight: 400;
        font-size: 14px;
        color: #263341;
        letter-spacing: 0;
        text-align: justify;
        line-height: 16px;
        max-width: 263px;
      }
      .order_item_room_type{
        height: 16px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(38,51,65,0.55);
        letter-spacing: 0;
        text-align: justify;
        line-height: 16px;
        max-width: 263px;
        margin-top: 4px;
      }
      .order_item_date{
        height: 12px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(38,51,65,0.55);
        letter-spacing: 0;
        text-align: justify;
        line-height: 12px;
        margin-top:8px;
      }
    }
    .order_money_box{
      margin: 0 12px;
      height: 50px;
      background: #FFFFFF;
      border-top: 1px solid #E9EAEC;
      .order_money_label{
        height: 20px;
        font-weight: 400;
        font-size: 14px;
        color: #263341;
        text-align: right;
        line-height: 20px;
      }
      .order_money_symbol{
        height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #263341;
        text-align: right;
        line-height: 20px;
      }
      .order_money_text{
        height: 26px;
        font-weight: 500;
        font-size: 24px;
        color: #263341;
        text-align: right;
        line-height: 26px;
      }
      .order_pay_button{
        width: 88px;
        height: 32px;
        padding: 0;
        border-radius: 16px;
        z-index: 0;
      }
    }
    .order_tip{
      height: 24px;
      background: #FFFBF0;
      border-radius: 0 0 8px 8px;
      font-weight: 400;
      font-size: 10px;
      color: #FFAA2B;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;
    }
  }
}
.order_empty{
  margin-top:80px;
  .order_empty_img{
    width: 120px;
    height: 120px;
  }
  .order_empty_text{
    height: 24px;
    font-weight: 400;
    font-size: 13px;
    color: rgba(38,51,65,0.55);
    text-align: center;
    line-height: 24px;
    margin-top: 12px;
  }
}
.order_one_note{
  height: 16px;
  font-weight: 500;
  font-size: 14px;
  color: #263341;
  letter-spacing: 0;
  text-align: justify;
  line-height: 16px;
  margin-bottom: 16px;
}
/deep/.van-cell::after{
  border: none;
}
</style>
